import React, { useContext, useCallback } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { TranslateFunc } from '@prisjakt/ui-translate/src/translate-func';
import { ProductCollectionNonNameSearchFilter } from '../types';
import RouteContext from '../../../../../routes/context';
import { trackProductCollectionFilterClear } from '../../../tracking';
import * as S from './styles';

type Props = {
  filter: ProductCollectionNonNameSearchFilter;
};

export const formatFilterValue = (
  filter: ProductCollectionNonNameSearchFilter,
  t: TranslateFunc
): string => {
  switch (filter.__typename) {
    case 'ProductCollectionTermsFilter': {
      const values = filter.values || filter.ids;
      return values.length > 3
        ? `${values.slice(0, 2).join(', ')}, +${values.length - 2}`
        : values.join(', ');
    }
    case 'ProductCollectionTermFilter':
      return filter.value || filter.id;
    case 'ProductCollectionRangeFilter':
      return `${filter.from} - ${filter.to}${
        filter.unit ? ` ${filter.unit}` : ''
      }`;
    case 'ProductCollectionRangeGroupFilter': {
      const values = Array.isArray(filter.values) ? filter.values : [filter.id];
      return values
        .map(value => (filter.unit ? `${value} ${filter.unit}` : value))
        .join(', ');
    }
    case 'ProductCollectionBooleanFilter':
      return t(
        'filter',
        filter.id === 'true'
          ? `properties.select-true`
          : `properties.select-false`
      );
    default:
      return '';
  }
};

const AppliedFilter = ({ filter }: Props) => {
  const { t } = useContext(AppContext);
  const { dispatch } = useContext(RouteContext);
  const clearFilter = useCallback(() => {
    trackProductCollectionFilterClear(filter.property);
    dispatch({ type: 'FILTER_REMOVE', property: filter.property });
  }, [dispatch, filter.property]);
  const formattedValue = formatFilterValue(filter, t);

  return (
    <S.AppliedFilter onClick={clearFilter} data-test="AppliedFilter">
      <S.AppliedFilterText>
        {filter.title
          ? t('filter', 'applied-filter.filter-with-name', {
              name: filter.title,
              value: formattedValue,
            })
          : formattedValue}
      </S.AppliedFilterText>
      <S.AppliedFilterIcon />
    </S.AppliedFilter>
  );
};

export default AppliedFilter;
